import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_106_add_product: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Add Product",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "product_add",
        TableName: "item_master",
        columnNumber: "m1 t1 w3",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        childComponents: [
          // Part No. (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_parts",
            label: "Part No.",
            placeholder: "Part no. / item code",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "part_no",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Part No. is required",
              },
            ],
          },
          // Item name (required)
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_itemname",
            label: "Item name",
            placeholder: "",
            required: true,
            inputType: InputType.TEXT,
            Json_Attribute: "item_name",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Item name is required",
              },
            ],
          },
          // Item group (required) - Select with product_group lookup
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "drp_group",
            label: "Item group",
            placeholder: "--Not Set--",
            required: true,
            lookupName: "product_group",
            options: [],
            Json_Attribute: "parent_id",
            PopupScreenId: "17",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Item group is required",
              },
            ],
          },
          // Origin - Search_Select with country lookup
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search__orign",
            label: "Origin",
            placeholder: "",
            required: false,
            lookupName: "country",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "origin",
          },
          // Rack/Bin
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_rackbin",
            label: "Rack/Bin",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "rack_bin",
          },
          // Remarks
          {
            componentType: ComponentType.TEXT_AREA,
            name: "txt_itemremarks",
            label: "Remarks",
            placeholder: "",
            required: false,
            Json_Attribute: "remarks",
            BindValue: "txt_itemremarks",
          },
          // Unit - Select with measurementunit lookup
          {
            componentType: ComponentType.SELECT_DROPDOWN,
            name: "s_search_itemunit",
            label: "Unit",
            placeholder: "--Not Set--",
            required: false,
            lookupName: "measurementunit",
            options: [],
            Json_Attribute: "unit",
           
          
          },
          // Department - Search_Select with department lookup
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "s_search_departments",
            label: "Department",
            placeholder: "",
            required: false,
            lookupName: "department",
            options: [],
            searchable: true,
            clearable: true,
            Json_Attribute: "department_id",
           
          },
          // Purchase rate (required) - Numeric
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_purchase_rate",
            label: "Purchase rate",
            placeholder: "",
            required: true,
            inputType: InputType.NUMBER,
            defaultValue: "0.00",
            Json_Attribute: "purchase_rate",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Purchase rate is required",
              },
            ],
          },
          // Sale rate (required) - Numeric
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_sale_rate",
            label: "Sale rate",
            placeholder: "",
            required: true,
            inputType: InputType.NUMBER,
            defaultValue: "0.00",
            Json_Attribute: "sale_rate",
            validation: [
              {
                rule: ValidationRule.REQUIRED,
                message: "Sale rate is required",
              },
            ],
          },
          // Sales account
          {
            componentType: ComponentType.TEXT_FIELD,
            name: "txt_sales_acc",
            label: "Sales account",
            placeholder: "",
            required: false,
            inputType: InputType.TEXT,
            Json_Attribute: "sales_account",
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Save",
        onPressAction: "save",
        style: {
          backgroundColor: "#22c55e",
        },
      },
    ],
  },
];
